import { Box, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Col } from "reactstrap";
import { useAvailableModulesContext } from "../../context/AvailableModulesContext";
import AssistancesFromClient from "../Assistances/AssistancesFromClient";
import EquipmentsFromClient from "../Equipments/EquipmentsFromClient";
import ClientProfitabilityTable from "../Profitability/ClientProfitabilityTable";
import ProjectsFromClient from "../Projects/ProjectsFromClient";
import MaintenancePlansFromClient from "../MaintenancePlans/MaintenancePlansFromClient";
import { Utilities } from "../../helpers/Utilities";

type ClientNavBarType = {
    clientId: number;
    reloadExecutions: boolean;
    childrenColumnSize?: number;
    loadingUpdate: boolean;

    clientErpId?: string | null;
    clientName?: string | null;
};

export function ClientNavBar({ clientId, reloadExecutions, childrenColumnSize = 12, loadingUpdate, ...props }: ClientNavBarType) {

    const intl = useIntl();
    const [activeTab, setActiveTab] = useState<number>(0);
    //const [isComplete, setIsComplete] = useState<boolean>(false);
    const [isActiveProfitabilityModule, setIsActiveProfitabilityModule] = useState<boolean>(false);
    const [isActiveProjectModule, setIsActiveProjectModule] = useState<boolean>(false);
    const [isActiveMaintenanceModule, setIsActiveMaintenanceModule] = useState<boolean>(false);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    const { availableModules } = useAvailableModulesContext();
    useEffect(() => {
        if (availableModules.includes("ProfitabilitySage50cIsActiveProfitabilityModule")) {
            setIsActiveProfitabilityModule(true);
        }
        if (availableModules.includes("ProjectSage50cIsActiveProjectModule")) {
            setIsActiveProjectModule(true);
        }
        if (availableModules.includes("IsActiveMaintenanceModule")) {
            setIsActiveMaintenanceModule(true);
        }
    }, [availableModules]);

    const dynamicTabs = Utilities.GetDynamicTabIndices(availableModules, 2);

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                >
                    <Tab label={intl.formatMessage({ id: "Screens.Client.Navbar.Assistances" })} {...a11yProps(0)} />
                    <Tab label={intl.formatMessage({ id: "Screens.Client.Navbar.Equipments" })} {...a11yProps(1)} />

                    {dynamicTabs.map((tab: { module: string, index: number }) => {
                        if (tab.module === "ProjectSage50cIsActiveProjectModule") {
                            return (
                                <Tab
                                    key={tab.index}
                                    label={intl.formatMessage({ id: "Screens.Client.Navbar.Projects" })}
                                    {...a11yProps(tab.index)}
                                />
                            );
                        }
                        if (tab.module === "ProfitabilitySage50cIsActiveProfitabilityModule") {
                            return (
                                <Tab
                                    key={tab.index}
                                    label={intl.formatMessage({ id: "Screens.Client.Navbar.Profitability" })}
                                    {...a11yProps(tab.index)}
                                />
                            );
                        }
                        if (tab.module === "IsActiveMaintenanceModule") {
                            return (
                                <Tab
                                    key={tab.index}
                                    label={intl.formatMessage({ id: "Screens.Client.Navbar.MaintenancePlans" })}
                                    {...a11yProps(tab.index)}
                                />
                            );
                        }
                        return null;
                    })}
                </Tabs>
            </Box>

            <TabPanel value={activeTab} index={0} childrenColumnSize={childrenColumnSize}>
                <AssistancesFromClient
                    clientErpId={props?.clientErpId}
                    clientName={props?.clientName}
                    showCreateNewAssistanceButton={true}
                    showKpiClientAssistancesHistoryDashboardButton={true}
                />
            </TabPanel>

            <TabPanel value={activeTab} index={1} childrenColumnSize={childrenColumnSize}>
                <EquipmentsFromClient
                    clientErpId={props?.clientErpId}
                    clientName={props?.clientName}
                />
            </TabPanel>

            {dynamicTabs.map((tab: { module: string, index: number }) => {
                if (tab.module === "ProjectSage50cIsActiveProjectModule") {
                    return (
                        <TabPanel key={tab.index} value={activeTab} index={tab.index} childrenColumnSize={childrenColumnSize}>
                            <ProjectsFromClient />
                        </TabPanel>
                    );
                }
                if (tab.module === "ProfitabilitySage50cIsActiveProfitabilityModule") {
                    return (
                        <TabPanel key={tab.index} value={activeTab} index={tab.index} childrenColumnSize={childrenColumnSize}>
                            <ClientProfitabilityTable
                                clientId={clientId}
                                reloadExecutions={reloadExecutions}
                                loadingUpdate={loadingUpdate}
                            />
                        </TabPanel>
                    );
                }
                if (tab.module === "IsActiveMaintenanceModule") {
                    return (
                        <TabPanel key={tab.index} value={activeTab} index={tab.index} childrenColumnSize={childrenColumnSize}>
                            <MaintenancePlansFromClient
                                clientErpId={props?.clientErpId}
                                clientName={props?.clientName}
                            />
                        </TabPanel>
                    );
                }
                return null;
            })}
        </>
    );
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    childrenColumnSize: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, childrenColumnSize, ...other } = props;

    return (
        <Col xl={childrenColumnSize}>
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <>{children}</>}
            </div>
        </Col>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
